var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYeapGo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153.69 52.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#1a1a1a;}.cls-3{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 0,
    width: 153.69,
    height: 52.69,
    rx: 26.35,
    ry: 26.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m20.3,16.92h6.81l3.03,6.73,3.03-6.73h6.7l-6.81,13.22v5.77h-5.95v-5.77l-6.81-13.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m53.87,21.67h-6.7v2.33h5.9v4.48h-5.9v2.68h6.7v4.75h-12.66v-18.99h12.66v4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m68.29,33.04h-6.33l-.94,2.87h-6.25l6.95-18.99h6.87l6.92,18.99h-6.28l-.94-2.87Zm-3.16-9.76l-1.72,5.28h3.43l-1.72-5.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m85.16,29.87h-2.36v6.03h-5.95v-18.99h8.31c4.77,0,7.21,2.68,7.21,6.52,0,3.51-2.44,6.44-7.21,6.44Zm-.67-4.69c1.34,0,1.85-.7,1.85-1.74s-.51-1.74-1.85-1.74h-1.69v3.49h1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m112.16,23.41h-6.28c-.46-.72-1.31-1.18-2.55-1.18-2.31,0-3.59,1.64-3.59,4.16,0,2.95,1.34,4.42,4.26,4.42,1.34,0,2.44-.48,3.33-1.66h-4.75v-4.21h9.68v5.95c-1.31,2.28-4,5.15-8.9,5.15-5.98,0-9.65-4-9.65-9.65s3.65-9.65,9.6-9.65c5.04,0,8.29,2.63,8.85,6.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m123.66,36.1c-5.39,0-9.79-4.05-9.79-9.76s4.4-9.73,9.79-9.73,9.73,4.02,9.73,9.73-4.37,9.76-9.73,9.76Zm0-5.55c2.39,0,3.7-1.69,3.7-4.21s-1.31-4.24-3.7-4.24-3.73,1.66-3.73,4.24,1.29,4.21,3.73,4.21Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYeapGo);
export default __webpack_public_path__ + "static/media/YeapGo.61e6ecd906c705e4e46cdc4fa9a48853.svg";
export { ForwardRef as ReactComponent };